"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StanfordTorus = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var SpaceName_1 = require("../../SpaceName");
var SpaceType_1 = require("../../SpaceType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var StanfordTorus = (function (_super) {
    __extends(StanfordTorus, _super);
    function StanfordTorus() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.STANFORD_TORUS,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.CITY],
            cost: 12,
            metadata: {
                cardNumber: 'X12',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.city().asterix();
                }),
                description: 'Place a city tile IN SPACE, outside and separate from the planet.',
                victoryPoints: 2,
            },
        }) || this;
    }
    StanfordTorus.prototype.play = function (player) {
        player.game.addCityTile(player, SpaceName_1.SpaceName.STANFORD_TORUS, SpaceType_1.SpaceType.COLONY);
        return undefined;
    };
    StanfordTorus.prototype.getVictoryPoints = function () {
        return 2;
    };
    return StanfordTorus;
}(Card_1.Card));
exports.StanfordTorus = StanfordTorus;
//# sourceMappingURL=StanfordTorus.js.map